import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { selectSiteSurveyForm } from '../../application_actions';
import { Navigator } from '../presentational/navigator.jsx';
import  SelectDropdown  from '../presentational/select_dropdown.jsx';
import makeBasePage from '../base_page.jsx';

const escalators = [
  "001", "005", "011"
]

const elevators = [
  "004", "010"
]
export class SiteSurveyFormSelection extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selection: undefined
    }
  }

  componentDidMount(){
    if(this.props.app?.iotData?.equipment?.EquipmentGeneralEquipmentType){
      if(elevators.indexOf(this.props.app.iotData.equipment.EquipmentGeneralEquipmentType) > -1){
        this.makeSelection({key:0,value:"ELEVATOR"})
      }else if(escalators.indexOf(this.props.app.iotData.equipment.EquipmentGeneralEquipmentType) > -1){
        this.makeSelection({key:1,value:"ESCALATOR"})
      }
    }
  }

  onValueChange(data) {
    this.makeSelection(data)
  }

  makeSelection(data){
    this.setState({
      selection: data
    });

    this.props.selectSiteSurveyForm(data.value);
  }

  continueDisabled() {

    return this.state.selection == undefined;
  }

  render() {
    // ESCALATOR option is removed for user validation purpose revert it back 
    var options = [ "ELEVATOR" ];

    return (
      <div className="page-view" id= "siteSurveyFormSelection">
        <div>
          <SelectDropdown
            id={"formTypeSelection"}
            key={"key"}
            strings={this.props.strings.SiteSurveyFormSelection.options}
            title={this.props.strings.SiteSurveyFormSelection.title}
            value={ this.state.selection || { key: undefined, value: undefined} }
            options={ options }
            onValueChange={(data) => this.onValueChange(data)}
            default={ this.props.strings.SiteSurveyFormSelection.selectElevatorType }
            other={ {otherOption: false }}
          />
          <Navigator
            continueText={ this.props.strings.Common.continue }
            backText={this.props.strings.Common.back}
            onContinue={() => this.props.goForward() }
            onBack={() => this.props.goBack() }
            continueDisabled={ this.continueDisabled() }
          />
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ selectSiteSurveyForm }, dispatch);
}

export default connect(null, mapDispatchToProps)(makeBasePage('SiteSurveyFormSelection')(SiteSurveyFormSelection));
